import {
    ConfigurationAutomaticBillableConceptRuleEntityType
} from '@/modules/configurationModule/detail/automation/billable-concepts/components/services/configuration-automatic-billable-concept/configuration-automatic-billable-concept-rule.dto'
import { EntityStatusState } from '@/store/root/root-store.model'
import { ConfigurationLaboratoryResponse } from '@/modules/configurationModule/shared/services/configuration.dto'
import { CommonProtocolResponse } from '@/api/services/common.dto'
import {
    ConfigurationBillableConceptResponse
} from '@/modules/configurationModule/detail/accounting/billable/concepts/services/configuration-billable-concept.dto'
import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'
import {
    CommonMostLikelyMorphologicCodeResponse
} from '@/api/services/common/most-likely-morphologic-code/common-most-likely-morphologic-code.dto'
import { CommonAssayResponse } from '@/api/services/common/assay/common-assay.dto'
import { Nullable } from '@/shared/types/app.types'

export interface ConfigurationAutomaticBillableConceptRuleModalState {
    id: number
    laboratory?: ConfigurationLaboratoryResponse
    entityType: EntityStatusState
    concept?: Nullable<ConfigurationBillableConceptResponse>
    caseType?: Nullable<CommonCaseTypeResponse>
    sampleType?: Nullable<CommonSampleTypeResponse>
    topographicCode?: Nullable<CommonTopographicCodeResponse>
    procedure?: Nullable<CommonProcedureResponse>
    mostLikelyMorphologicCode?: Nullable<CommonMostLikelyMorphologicCodeResponse>
    protocol?: Nullable<CommonProtocolResponse>
    active: boolean
    assay?: Nullable<CommonAssayResponse>
    rulePriority: number
}
export const initialConfigurationAutomaticBillableConceptRuleModalState =
    (): ConfigurationAutomaticBillableConceptRuleModalState => ({
        id: -1,
        active: true,
        rulePriority: 1,
        entityType: Object.values(ConfigurationAutomaticBillableConceptRuleEntityType)[0]
    })
